import utils from '@/common/utils'
import config from '@/common/config'

export default {
  web_login,
  wxmp_login
}

/**
 * 微信网站应用登录（PC扫码登录）
 * @param {Object} params 包含 code（微信授权码）、livingid（直播ID）、key（邀约码）
 * @returns {Promise} 后端返回 { code, message, url, unionid, livingid, key, nickname, avatar, need_update_profile }
 */
function web_login(params) {
  return new Promise((resolve, reject) => {
    var baseUrl = config.vhApi || config.livingApi;
    if (baseUrl.charAt(baseUrl.length - 1) !== "/") {
      baseUrl += "/"
    }
    var url = baseUrl + "web/login";
    utils.ajax("POST", url, params, 10000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}

/**
 * 微信公众号登录（微信内浏览器H5网页授权）
 * @param {Object} params 包含 code（微信授权码）、livingid（直播ID）、key（邀约码）
 * @returns {Promise} 后端返回 { code, message, url, unionid, livingid, key, nickname, avatar, need_update_profile }
 */
function wxmp_login(params) {
  return new Promise((resolve, reject) => {
    var baseUrl = config.vhApi || config.livingApi;
    if (baseUrl.charAt(baseUrl.length - 1) !== "/") {
      baseUrl += "/"
    }
    var url = baseUrl + "wxmp/login";
    utils.ajax("POST", url, params, 10000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}
